<script setup lang="ts">
  import { onMounted, onUnmounted } from 'vue';
  import { useDashboardStore } from '../model/dashboard.store';
  import DashboardFilterBar from './DashboardFilterBar.vue';
  import ActiveCollaboratorsWidget from './widgets/ActiveCollaboratorsWidget.vue';
  import ApprovalStatusWidget from './widgets/ApprovalStatusWidget.vue';
  import DocumentTotalsCards from './widgets/DocumentTotalsCards.vue';
  import DocumentTypesWidget from './widgets/DocumentTypesWidget.vue';
  import HomologationLeadTimeWidget from './widgets/HomologationLeadTimeWidget.vue';
  import RecordsManagementWidget from './widgets/RecordsManagementWidget.vue';
  import TrainingByDepartmentWidget from './widgets/TrainingByDepartmentWidget.vue';
  import TrainingStatusWidget from './widgets/TrainingStatusWidget.vue';
  import TrainingTypesWidget from './widgets/TrainingTypesWidget.vue';

  const dashboardStore = useDashboardStore();

  onMounted(() => {
    dashboardStore.fetchDashboard();
  });

  onUnmounted(() => {
    dashboardStore.reset();
  });
</script>

<template>
  <div class="w-full min-w-[1100px] px-6 pb-6">
    <h1 class="mt-4 text-left text-xl/7.5 font-semibold text-gray-07">
      Dashboard
    </h1>
    <DashboardFilterBar class="mt-6" />
    <div
      data-testid="dashboard-widgets"
      class="mt-6 flex flex-col gap-5"
    >
      <DocumentTotalsCards />
      <div class="flex gap-5">
        <div class="flex min-w-0 flex-[712] flex-col gap-5">
          <ApprovalStatusWidget class="h-[476px]" />
          <RecordsManagementWidget class="h-[464px]" />
          <TrainingTypesWidget class="h-[367px]" />
        </div>
        <div class="flex min-w-0 flex-[420] flex-col gap-5">
          <HomologationLeadTimeWidget class="h-[578px]" />
          <DocumentTypesWidget class="h-[362px]" />
          <TrainingStatusWidget class="h-[362px]" />
        </div>
      </div>
      <TrainingByDepartmentWidget class="h-[306px]" />
      <ActiveCollaboratorsWidget class="h-[306px]" />
    </div>
  </div>
</template>

<style>
  .dashboard-export-stage,
  .dashboard-export-stage * {
    transition: none !important;
    animation: none !important;
  }
</style>
